import React from 'react';
import {FaFacebook,FaTwitter,FaYoutube,FaInstagram,FaPinterest} from 'react-icons/fa';

const Footer = () => {
  return (
    <div className='w-full bg-gray-100 py-16'>

        <div className='max-w-[1240px] mx-auto flex flex-col px-4'>
        <div className='sm:flex text-center justify-between items-center'>
            <h1>Beaches.</h1>
            <div className='flex justify-between w-full sm:max-w-[200px] my-4'> 
                <FaFacebook  className='icon'   />
                <FaTwitter   className='icon'   />
                <FaYoutube   className='icon'   />
                <FaInstagram className='icon'   />
                <FaPinterest className='icon'   />
                </div>
        </div>
        <div className='flex justify-between'>
        <ul className=''>
            <li>About</li>
            <li>Partnerships</li>
            <li>Careers</li>
            <li>Newsroom</li>
            <li>Advertising</li>
        </ul>
        <ul className='text-right '>
            <li>Home</li>
            <li>Destination</li>
            <li>Travel</li>
            <li>View</li>
            <li>Book</li>
        </ul>
        </div>

        </div>
    </div>
  )
}

export default Footer